import { useState, useRef, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

// ─── Estilos y Configuración ──────────────────────────────────────────────────
const BRAND_GREEN = "#266e6b";
const BRAND_MINT = "#36FF9B";
 
const GLOBAL_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;700;900&display=swap');
  *, *::before, *::after { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; width: 100%; height: 100%; }
  body {
    background: #f0f4f8;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    min-height: 100vh;
    font-family: 'Outfit', sans-serif;
    -webkit-font-smoothing: antialiased;
  }
  @keyframes spin      { to { transform: rotate(360deg); } }
  @keyframes shake     { 0%{transform:translateX(0)} 15%{transform:translateX(-9px)} 30%{transform:translateX(9px)} 45%{transform:translateX(-6px)} 60%{transform:translateX(6px)} 80%{transform:translateX(-3px)} 100%{transform:translateX(0)} }
  @keyframes digitPop  { 0%{transform:scale(1)} 40%{transform:scale(1.28)} 70%{transform:scale(0.92)} 100%{transform:scale(1)} }
  @keyframes fadeUp    { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
  @keyframes fadeDown  { from{opacity:0;transform:translateY(-16px)} to{opacity:1;transform:translateY(0)} }
  @keyframes lockPop   { 0%{transform:scale(0.3) rotate(-15deg);opacity:0} 60%{transform:scale(1.18) rotate(4deg);opacity:1} 80%{transform:scale(0.94) rotate(-2deg)} 100%{transform:scale(1) rotate(0deg);opacity:1} }
  @keyframes glowGreen { 0%,100%{box-shadow:0 0 0 0 rgba(38,110,107,0)} 50%{box-shadow:0 0 0 18px rgba(38,110,107,0.18)} }
  @keyframes logoPulse { 0%{transform:scale(0.82);opacity:0} 60%{transform:scale(1.05)} 100%{transform:scale(1);opacity:1} }
  @keyframes splashOut { 0%{opacity:1;transform:scale(1)} 100%{opacity:0;transform:scale(1.06)} }

  .digit-pop    { animation: digitPop 0.22s ease; }
  .digits-shake { animation: shake 0.5s ease; }
  .lock-anim    { animation: lockPop 0.6s cubic-bezier(.36,.07,.19,.97) both, glowGreen 1.6s ease 0.6s 2; }
  .screen-in    { animation: fadeUp 0.38s ease; }
  .title-in     { animation: fadeDown 0.35s ease; }

  .splash {
    position: fixed; inset: 0;
    background: #ffffff; 
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    z-index: 9999;
    animation: logoPulse 0.8s ease;
  }
  .splash.hiding { animation: splashOut 0.7s ease forwards; }

  .digit-input {
    width: clamp(50px, 14vw, 68px);
    height: clamp(70px, 18.5vw, 90px);
    font-size: clamp(30px, 7.5vw, 40px);
    border-radius: 12px;
    border: 1.5px solid #d3d3d3;
    text-align: center;
    font-family: 'Outfit', monospace;
    background: #fff;
    color: #111;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    touch-action: manipulation;
  }
  .digit-input.filled { border-color: ${BRAND_GREEN}; box-shadow: 0 0 0 3px rgba(38,110,107,0.13); }
  .digit-input:focus  { border-color: ${BRAND_GREEN}; }

  .submit-btn {
    width: 100%; border: none; border-radius: 22px;
    padding: clamp(12px,3vw,15px) 0;
    font-size: clamp(0.88rem,3vw,1rem);
    font-weight: 700; letter-spacing: 1px;
    color: #fff; cursor: pointer; margin-top: 20px;
    transition: background 0.3s, box-shadow 0.3s;
    font-family: 'Outfit', sans-serif;
  }
  .submit-btn.active   { background: ${BRAND_GREEN}; box-shadow: 6px 6px 6px #cbced1, -6px -6px 6px #fff; }
  .submit-btn.active:hover { background: #1e5654; }
  .submit-btn.disabled { background: ${BRAND_GREEN}; opacity: 0.4; cursor: not-allowed; box-shadow: none; }

  .icon-btn {
    background: none; border: none; cursor: pointer;
    color: #888; font-size: 13px;
    display: flex; align-items: center; gap: 5px; padding: 0;
    font-family: 'Outfit', sans-serif;
    touch-action: manipulation;
  }

  .card {
    background: #fff; border-radius: 24px;
    padding: clamp(22px,5vw,40px) clamp(18px,6vw,36px) clamp(20px,4vw,30px);
    width: min(92vw, 390px);
    text-align: center;
    box-shadow: 0 4px 32px rgba(0,0,0,0.10);
    position: relative;
  }

  .footer-links {
    display: flex; justify-content: center; align-items: center;
    width: min(92vw, 390px);
    margin-top: 16px;
  }
  .footer-link {
    color: #b0bec5; font-size: clamp(10px,2.3vw,11.5px);
    text-decoration: none; font-family: 'Outfit', sans-serif;
    transition: color 0.2s;
    display: flex; align-items: center; gap: 4px;
  }
  .footer-link:hover { color: ${BRAND_GREEN}; text-decoration: underline; }

  .overlay-wrap {
    display: flex; flex-direction: column; align-items: center; gap: 16px;
    padding: 12px 0 20px; animation: fadeUp 0.3s ease;
  }
  .overlay-text {
    margin: 0; font-size: clamp(0.82rem,2.5vw,0.92rem);
    color: #444; font-weight: 500; font-family: 'Outfit', sans-serif;
  }
  .modal-backdrop {
    position: fixed; inset: 0; background: rgba(0,0,0,0.45);
    display: flex; align-items: center; justify-content: center;
    z-index: 1000; animation: fadeUp 0.25s ease; padding: 20px;
  }
  .modal-box {
    background: #fff; border-radius: 18px;
    padding: clamp(22px,5vw,32px) clamp(18px,5vw,28px);
    max-width: min(88vw, 340px); width: 100%; text-align: center;
    box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  }
`;

function injectStyles() {
  if (document.getElementById("rac-styles")) return;
  const el = document.createElement("style");
  el.id = "rac-styles";
  el.textContent = GLOBAL_STYLES;
  document.head.appendChild(el);
}

const TRANSLATIONS = {
  en: { title:"REMOTE CODE ACCESS SYSTEM", welcome:"Welcome", welcomeDesc:"Enter the 6-digit code you received to access the system remotely.", step1:"Select your language", step2:"Enter your 6-digit code", step3:"Press Confirm to send", start:"Start", confirm:"CONFIRM", clearAll:"Clear", fetchingPermissions:"Fetching server permissions", executingAction:"Executing action", openOrderExecuted:"Action completed successfully", errorTitle:"Link without permissions", errorBody:"Please regenerate the link with permissions for current dates.", errorClose:"Close", showCode:"Show code", hideCode:"Hide code", webLink:"www.ayr.es" },
  sp: { title:"SISTEMA DE ACCESO POR CÓDIGO REMOTO", welcome:"Bienvenido", welcomeDesc:"Introduce el código de 6 dígitos que has recibido para acceder al sistema de forma remota.", step1:"Selecciona tu idioma", step2:"Introduce tu código de 6 dígitos", step3:"Pulsa Confirmar para enviar", start:"Comenzar", confirm:"CONFIRMAR", clearAll:"Borrar", fetchingPermissions:"Obteniendo permisos del servidor", executingAction:"Ejecutando acción", openOrderExecuted:"Acción realizada correctamente", errorTitle:"Enlace sin permisos", errorBody:"Vuelva a generar el enlace con permisos para las fechas actuales.", errorClose:"Cerrar", showCode:"Mostrar código", hideCode:"Ocultar código", webLink:"www.ayr.es" },
  fr: { title:"SYSTÈME D'ACCÈS PAR CODE À DISTANCE", welcome:"Bienvenue", welcomeDesc:"Saisissez le code à 6 chiffres reçu para accéder au système.", step1:"Choisissez votre langue", step2:"Entrez votre code à 6 chiffres", step3:"Appuyez sur Confirmer", start:"Commencer", confirm:"CONFIRMER", clearAll:"Effacer", fetchingPermissions:"Obtention des permissions du serveur", executingAction:"Exécution de l'action", openOrderExecuted:"Action réalisée avec succès", errorTitle:"Lien sans permissions", errorBody:"Veuillez regénérer le lien.", errorClose:"Fermer", showCode:"Afficher", hideCode:"Masquer", webLink:"www.ayr.es" },
  de: { title:"FERNZUGRIFF-CODE-SYSTEM", welcome:"Willkommen", welcomeDesc:"Geben Sie den 6-stelligen Code ein, um remote zuzugreifen.", step1:"Wählen Sie Ihre Sprache", step2:"Geben Sie Ihren Code ein", step3:"Drücken Sie Bestätigen", start:"Starten", confirm:"BESTÄTIGEN", clearAll:"Löschen", fetchingPermissions:"Berechtigungen werden abgerufen", executingAction:"Aktion wird ausgeführt", openOrderExecuted:"Aktion erfolgreich ausgeführt", errorTitle:"Link ohne Berechtigungen", errorBody:"Bitte generieren Sie den Link neu.", errorClose:"Schließen", showCode:"Anzeigen", hideCode:"Verbergen", webLink:"www.ayr.es" },
  pt: { title:"SISTEMA DE ACESSO POR CÓDIGO REMOTO", welcome:"Bem-vindo", welcomeDesc:"Introduza o código de 6 dígitos para aceder remotamente.", step1:"Selecione o seu idioma", step2:"Introduza o seu código", step3:"Prima Confirmar", start:"Começar", confirm:"CONFIRMAR", clearAll:"Limpar", fetchingPermissions:"Obtendo permissões do servidor", executingAction:"Executando ação", openOrderExecuted:"Ação realizada com sucesso", errorTitle:"Link sem permissões", errorBody:"Por favor, gere novamente o link.", errorClose:"Fechar", showCode:"Mostrar", hideCode:"Ocultar", webLink:"www.ayr.es" },
  it: { title:"SISTEMA DI ACCESSO REMOTO CON CODICE", welcome:"Benvenuto", welcomeDesc:"Inserisci il codice a 6 cifre ricevuto per accedere al sistema.", step1:"Seleziona la tua lingua", step2:"Inserisci il codice a 6 cifre", step3:"Premi Conferma", start:"Inizia", confirm:"CONFERMA", clearAll:"Cancella", fetchingPermissions:"Recupero permessi dal server", executingAction:"Esecuzione azione", openOrderExecuted:"Azione eseguita correttamente", errorTitle:"Link senza permessi", errorBody:"Si prega di rigenerare il link.", errorClose:"Chiudi", showCode:"Mostra", hideCode:"Nascondi", webLink:"www.ayr.es" },
  pl: { title:"SYSTEM ZDALNEGO DOSTĘPU KODEM", welcome:"Witamy", welcomeDesc:"Wprowadź 6-cyfrowy kod, aby uzyskać zdalny dostęp.", step1:"Wybierz swój język", step2:"Wprowadź kod", step3:"Naciśnij Potwierdź", start:"Rozpocznij", confirm:"POTWIERDŹ", clearAll:"Wyczyść", fetchingPermissions:"Pobieranie uprawnień serwera", executingAction:"Wykonywanie akcji", openOrderExecuted:"Akcja wykonana pomyślnie", errorTitle:"Link bez uprawnień", errorBody:"Proszę wygenerować ponownie link.", errorClose:"Zamknij", showCode:"Pokaż", hideCode:"Ukryj", webLink:"www.ayr.es" },
  el: { title:"ΣΥΣΤΗΜΑ ΑΠΟΜΑΚΡΥΣΜΕΝΗΣ ΠΡΟΣΒΑΣΗΣ", welcome:"Καλώς ήρθατε", welcomeDesc:"Εισαγάγετε τον 6ψήφιο κωδικό.", step1:"Επιλέξτε γλώσσα", step2:"Εισαγάγετε κωδικό", step3:"Πατήστε Επιβεβαίωση", start:"Έναρξη", confirm:"ΕΠΙΒΕΒΑΙΩΣΗ", clearAll:"Εκκαθάριση", fetchingPermissions:"Λήψη δικαιωμάτων", executingAction:"Εκτέλεση ενέργειας", openOrderExecuted:"Η ενέργεια εκτελέστηκε", errorTitle:"Σύνδεσμος χωρίς δικαιώματα", errorBody:"Αναδημιουργήστε τον σύνδεσμο.", errorClose:"Κλείσιμο", showCode:"Εμφάνιση", hideCode:"Απόκρυψη", webLink:"www.ayr.es" },
  nl: { title:"SYSTEEM VOOR EXTERNE TOEGANG", welcome:"Welkom", welcomeDesc:"Voer de 6-cijferige code in om op afstand toegang te krijgen.", step1:"Selecteer uw taal", step2:"Voer uw code in", step3:"Druk op Bevestigen", start:"Starten", confirm:"BEVESTIGEN", clearAll:"Wissen", fetchingPermissions:"Servermachtigingen ophalen", executingAction:"Actie uitvoeren", openOrderExecuted:"Actie succesvol uitgevoerd", errorTitle:"Link zonder rechten", errorBody:"Genereer de link opnieuw.", errorClose:"Sluiten", showCode:"Tonen", hideCode:"Verbergen", webLink:"www.ayr.es" },
};

const LANGUAGE_OPTIONS = [
  {value:"en",label:"English"},{value:"sp",label:"Español"},{value:"fr",label:"Français"},
  {value:"de",label:"Deutsch"},{value:"pt",label:"Português"},{value:"it",label:"Italiano"},
  {value:"pl",label:"Polski"},{value:"el",label:"Ελληνικά"},{value:"nl",label:"Nederlands"},
];

function detectLanguage() {
  const b = (navigator.language || "en").toLowerCase().split("-")[0];
  const map = { es:"sp", pt:"pt", fr:"fr", de:"de", it:"it", pl:"pl", el:"el", nl:"nl" };
  const r = map[b] || b;
  return TRANSLATIONS[r] ? r : "en";
}

// ─── SVG Components ───────────────────────────────────────────────────────────
const AyrLogo = ({ size = 38 }) => (
  <div className="brand-logo" style={{ display:"flex", alignItems:"center", justifyContent:"center" }}>
    <img 
      src="/AYR_LOGO_BRAND.png" 
      alt="AYR Logo" 
      style={{ height: 38, width: "auto", display: "block" }} 
    />
  </div>
);

const LockClosedIcon = ({ size=28, color="white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);

const LockOpenIcon = () => (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2"/>
    <path d="M7 11V7a5 5 0 0 1 9.9-1"/>
    <circle cx="12" cy="16" r="1.5" fill="white" stroke="none"/>
  </svg>
);

const WarningIcon = () => (
  <svg width="52" height="52" viewBox="0 0 24 24" fill="none">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" fill={BRAND_MINT} stroke={BRAND_MINT} strokeWidth="0.5"/>
    <line x1="12" y1="9" x2="12" y2="13" stroke={BRAND_GREEN} strokeWidth="2.2" strokeLinecap="round"/>
    <circle cx="12" cy="17" r="1.1" fill={BRAND_GREEN}/>
  </svg>
);

const EyeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
  </svg>
);

const EyeOffIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
    <path d="M10 11v6M14 11v6"/>
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
  </svg>
);

const GlobeIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);



function Splash({ hiding }) {
  return (
    <div className={`splash${hiding ? " hiding" : ""}`}>
      <img 
        src="/AYR_LOGO_BRAND.png" 
        alt="AYR Logo" 
        style={{ width: "240px", height: "auto" }} 
        // Añadimos un manejador de error por si la ruta falla
        onError={(e) => console.error("No se pudo cargar el logo en /public/LOGO_AYR_BRAND.webp")}
      />
    </div>
  );
}




function WelcomeScreen({ t, lang, onStart, onLangChange }) {
  return (
    <div className="screen-in" style={{ textAlign:"center" }}>
      <div style={{ width:64, height:64, borderRadius:"50%", background:BRAND_GREEN, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 18px" }}>
        <LockClosedIcon size={28} color="white"/>
      </div>
      <h2 style={{ margin:"0 0 10px", fontSize:"clamp(1.1rem,4vw,1.3rem)", fontWeight:700, color:"#0f1011", fontFamily:"Outfit,sans-serif" }}>{t.welcome}</h2>
      <p style={{ margin:"0 0 18px", fontSize:"clamp(0.78rem,2.4vw,0.86rem)", color:"#666", lineHeight:1.6, fontFamily:"Outfit,sans-serif" }}>{t.welcomeDesc}</p>
      <div style={{ background:"#f7f9fc", borderRadius:12, padding:"12px 14px", marginBottom:16, textAlign:"left" }}>
        {[t.step1, t.step2, t.step3].map((step, i) => (
          <div key={i} style={{ display:"flex", alignItems:"center", gap:10, marginBottom: i < 2 ? 10 : 0 }}>
            <div style={{ width:22, height:22, borderRadius:"50%", background:BRAND_GREEN, color:"#fff", display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, flexShrink:0 }}>{i+1}</div>
            <span style={{ fontSize:"clamp(0.74rem,2.1vw,0.81rem)", color:"#444", fontFamily:"Outfit,sans-serif" }}>{step}</span>
          </div>
        ))}
      </div>
      <select value={lang} onChange={(e) => onLangChange(e.target.value)}
        style={{ width:"100%", border:"1px solid #d3d3d3", borderRadius:10, fontFamily:"Outfit,sans-serif", fontSize:"clamp(13px,3vw,14px)", padding:"8px 12px", marginBottom:14, color:"#333", background:"#fff", cursor:"pointer" }}>
        {LANGUAGE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      <button onClick={onStart} className="submit-btn active" style={{ marginTop:0, fontFamily:"Outfit,sans-serif" }}>{t.start} →</button>
    </div>
  );
}

function SpinnerFetching() {
  return (
    <svg width="52" height="52" viewBox="0 0 48 48" style={{ animation:"spin 1s linear infinite" }}>
      <circle cx="24" cy="24" r="20" fill="none" stroke="#e0e0e0" strokeWidth="4"/>
      <circle cx="24" cy="24" r="20" fill="none" stroke={BRAND_GREEN} strokeWidth="4" strokeDasharray="30 96" strokeLinecap="round"/>
    </svg>
  );
}

function SpinnerLoading({ onComplete }) {
  const ref = useRef(null);
  useEffect(() => {
    const C = 2 * Math.PI * 20;
    if (!ref.current) return;
    ref.current.style.strokeDasharray = C;
    ref.current.style.strokeDashoffset = C;
    let start = null;
    function animate(ts) {
      if (!start) start = ts;
      const p = Math.min((ts - start) / 5000, 1);
      if (ref.current) ref.current.style.strokeDashoffset = C * (1 - p);
      if (p < 1) requestAnimationFrame(animate);
      else if (onComplete) onComplete();
    }
    requestAnimationFrame(animate);
  }, [onComplete]);
  return (
    <svg width="52" height="52" viewBox="0 0 48 48">
      <circle cx="24" cy="24" r="20" fill="none" stroke="#e0e0e0" strokeWidth="4"/>
      <circle ref={ref} cx="24" cy="24" r="20" fill="none" stroke={BRAND_GREEN} strokeWidth="4"
        strokeLinecap="round" style={{ transform:"rotate(-90deg)", transformOrigin:"center" }}/>
    </svg>
  );
}

function UnlockSuccess() {
  return (
    <div className="lock-anim" style={{ width:74, height:74, borderRadius:"50%", background:BRAND_GREEN, display:"flex", alignItems:"center", justifyContent:"center" }}>
      <LockOpenIcon/>
    </div>
  );
}

function ErrorModal({ t, onClose }) {
  return (
    <div className="modal-backdrop">
      <div className="modal-box">
        <div style={{ marginBottom:12 }}><WarningIcon/></div>
        <p style={{ fontWeight:700, fontSize:"clamp(0.86rem,3vw,1rem)", color:BRAND_GREEN, margin:"0 0 8px", fontFamily:"Outfit,sans-serif" }}>{t.errorTitle}</p>
        <p style={{ fontSize:"clamp(0.76rem,2.4vw,0.86rem)", color:"#555", lineHeight:1.5, margin:"0 0 20px", fontFamily:"Outfit,sans-serif" }}>{t.errorBody}</p>
        <button onClick={onClose} className="submit-btn active" style={{ marginTop:0, padding:"10px 32px", width:"auto", fontFamily:"Outfit,sans-serif" }}>{t.errorClose}</button>
      </div>
    </div>
  );
}

function FooterLinks({ t }) {
  return (
    <div className="footer-links">
      <a href="https://www.ayr.es" target="_blank" rel="noreferrer" className="footer-link">
        <GlobeIcon/> {t.webLink}
      </a>
    </div>
  );
}

injectStyles();

// ─── Main App ─────────────────────────────────────────────────────────────────
export default function App() {

  const [splashHiding, setSplashHiding] = useState(false);
  const [splashDone, setSplashDone] = useState(false);
  const [lang, setLang] = useState(detectLanguage);
  const [screen, setScreen] = useState("welcome");
  const [digits, setDigits] = useState(Array(6).fill(""));
  const [showDigits, setShowDigits] = useState(true);
  const [phase, setPhase] = useState("idle");
  const [shaking, setShaking] = useState(false);
  const inputRefs = useRef([]);
  const t = TRANSLATIONS[lang];

  const isFull = digits.every((d) => d !== "");
  const hasDigits = digits.some((d) => d !== "");
  const isOverlay = phase !== "idle";

  const [searchParams] = useSearchParams();
  // Limpiamos la query sacando el último carácter si es necesario
  const QueryVal = searchParams.toString().substring(0, searchParams.toString().length - 1);

  useEffect(() => {
    const t1 = setTimeout(() => setSplashHiding(true), 2500);
    const t2 = setTimeout(() => setSplashDone(true), 3200);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  const focusFirst = useCallback(() => setTimeout(() => inputRefs.current[0]?.focus(), 80), []);
  const handleStart = useCallback(() => { setScreen("pin"); focusFirst(); }, [focusFirst]);

  const triggerShake = useCallback(() => {
    setShaking(true);
    setTimeout(() => setShaking(false), 520);
  }, []);

  const handleDigitChange = useCallback((index, value) => {
    const cleaned = value.replace(/\D/g, "").slice(-1);
    setDigits((prev) => { const n = [...prev]; n[index] = cleaned; return n; });
    if (cleaned) {
      const el = inputRefs.current[index];
      if (el) {
        el.classList.remove("digit-pop"); void el.offsetWidth;
        el.classList.add("digit-pop");
        el.addEventListener("animationend", () => el.classList.remove("digit-pop"), { once:true });
      }
      if (index < 5) inputRefs.current[index + 1]?.focus();
    }
  }, []);

  const handleKeyDown = useCallback((index, e) => {
    if (e.key === "Backspace") {
      if (digits[index] === "" && index > 0) inputRefs.current[index - 1]?.focus();
      else setDigits((prev) => { const n = [...prev]; n[index] = ""; return n; });
    } else if (e.key === "ArrowLeft" && index > 0) inputRefs.current[index - 1]?.focus();
    else if (e.key === "ArrowRight" && index < 5) inputRefs.current[index + 1]?.focus();
  }, [digits]);

  const handlePaste = useCallback((e) => {
    e.preventDefault();
    const p = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!p) return;
    setDigits((prev) => { const n = [...prev]; for (let i = 0; i < 6; i++) n[i] = p[i] || ""; return n; });
    inputRefs.current[Math.min(p.length, 5)]?.focus();
  }, []);

  const handleClear = useCallback(() => { setDigits(Array(6).fill("")); focusFirst(); }, [focusFirst]);

  // MODIFICACIÓN: Función handleSubmit definida correctamente en el nivel superior
  const handleSubmit = useCallback(async () => {
    const expectedLength = parseInt(process.env.REACT_APP_QUERY_LENGTH, 10);
    
    // 2. USAMOS la variable aquí para validar
    if (QueryVal.length !== expectedLength) {
      //console.warn(`Longitud incorrecta. Esperada: ${expectedLength}, Recibida: ${QueryVal.length}`);
      triggerShake();
      return; // Detenemos la ejecución si no coinciden
    }

    if (!isFull) return;

    setPhase("fetching");
    
    try {
      const pinCodeString = digits.join(""); // Convertimos el array de dígitos a string

      // Nota: mode: "no-cors" hará que no puedas leer si la respuesta fue exitosa o no.
      const response = await fetch(process.env.REACT_APP_URL_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          EncryptedCode: QueryVal,
          RandomCode: pinCodeString
        }),
      });

      setDigits(Array(6).fill(""));

      // MODIFICACIÓN AQUÍ:
      // Si es 'no-cors', ignoramos que response.ok sea false
      //if (response.type !== 'opaque' && !response.ok) {
        //throw new Error("Bad Connection");
      //}

      // Si llega aquí, pasamos al estado de loading/éxito
      setPhase("loading");

      // Con no-cors, response.ok siempre será falso y el body estará vacío.
      //if (!response.ok && response.type !== 'opaque') throw new Error("not ok");
      
      //setPhase("loading");
    } catch (err) {
      setDigits(Array(6).fill(""));
      triggerShake();

      setPhase("loading");
      //setTimeout(() => setPhase("error"), 120);
    }
  }, [isFull, digits, QueryVal, triggerShake]);

  const resetToIdle = useCallback(() => { setPhase("idle"); focusFirst(); }, [focusFirst]);

  return (
    <>
      {!splashDone && <Splash hiding={splashHiding}/>}

      <div style={{ display:"flex", flexDirection:"column", alignItems:"center", minHeight:"100vh", justifyContent:"center", padding:"20px 0", opacity: splashHiding ? 1 : 0, 
      visibility: splashHiding ? "visible" : "hidden",
      transition: "opacity 0.6s ease-in-out" }}>
        <div className="card">
          {screen === "pin" && (
            <div style={{ 
                display: "flex", 
                flexDirection: "column", 
                alignItems: "center", 
                gap: "12px",          // Espacio entre el select y el logo
                marginBottom: "20px",  // Espacio antes de los dígitos o el texto de bienvenida
                marginTop: "5px"
              }}>
           
              <select value={lang} onChange={(e) => setLang(e.target.value)}
                style={{ border:"1px solid #d3d3d3", borderRadius:8, fontFamily:"Outfit,sans-serif", fontSize:12, padding:"3px 7px", cursor:"pointer", background:"#fff" }}>
                {LANGUAGE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>
          )}

          <div style={{ marginBottom: screen === "pin" ? 0 : 4 }}>
            <a href="https://ayr.es" target="_blank" rel="noreferrer" style={{ display:"block", textDecoration:"none" }}>
              <AyrLogo size={60}/>
            </a>
          </div>

          {screen === "welcome" && (
            <div style={{ marginTop:14 }}>
              <WelcomeScreen t={t} lang={lang} onStart={handleStart} onLangChange={setLang}/>
            </div>
          )}

          {screen === "pin" && (
            <>
              <p className="title-in" style={{ color:"#0f1011", fontSize:"clamp(0.72rem,2.3vw,0.9rem)", fontWeight:600, letterSpacing:0.4, margin:"20px 0 20px", fontFamily:"Outfit,sans-serif" }}>
                {t.title}
              </p>

              {isOverlay && phase !== "error" && (
                <div className="overlay-wrap">
                  {phase === "fetching" && <SpinnerFetching/>}
                  {phase === "loading"  && <SpinnerLoading onComplete={() => setPhase("done")}/>}
                  {phase === "done"     && <UnlockSuccess/>}
                  <p className="overlay-text" style={{ color: phase === "done" ? BRAND_GREEN : "#444", fontWeight: phase === "done" ? 700 : 500 }}>
                    {phase === "fetching" && t.fetchingPermissions}
                    {phase === "loading"  && t.executingAction}
                    {phase === "done"     && t.openOrderExecuted}
                  </p>
                  {phase === "done" && (
                    <button onClick={resetToIdle} className="submit-btn active" style={{ marginTop:4, padding:"10px 36px", width:"auto", fontFamily:"Outfit,sans-serif" }}>OK</button>
                  )}
                </div>
              )}

              {!isOverlay && (
                <div className="screen-in">
                  <div className={shaking ? "digits-shake" : ""} style={{ display:"flex", justifyContent:"center", gap:"clamp(4px,1.8vw,9px)", marginBottom:10 }}>
                    {digits.map((d, i) => (
                      <input key={i}
                        ref={(el) => (inputRefs.current[i] = el)}
                        className={`digit-input${d ? " filled" : ""}`}
                        inputMode="numeric" pattern="[0-9]*"
                        type={showDigits ? "text" : "password"}
                        maxLength={1} value={d}
                        onChange={(e) => handleDigitChange(i, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(i, e)}
                        onPaste={i === 0 ? handlePaste : undefined}
                        autoComplete="off"
                      />
                    ))}
                  </div>

                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:8 }}>
                    <button className="icon-btn" onClick={() => setShowDigits((v) => !v)}>
                      {showDigits ? <EyeIcon/> : <EyeOffIcon/>}
                      <span style={{ fontFamily:"Outfit,sans-serif" }}>{showDigits ? t.hideCode : t.showCode}</span>
                    </button>
                    <button className="icon-btn" onClick={handleClear} disabled={!hasDigits}
                      style={{ color: hasDigits ? "#e53e3e" : "#ccc", cursor: hasDigits ? "pointer" : "default", opacity: hasDigits ? 1 : 0.4 }}>
                      <TrashIcon/>
                      <span style={{ fontFamily:"Outfit,sans-serif" }}>{t.clearAll}</span>
                    </button>
                  </div>

                  <button onClick={handleSubmit} disabled={!isFull}
                    className={`submit-btn ${isFull ? "active" : "disabled"}`}
                    style={{ fontFamily:"Outfit,sans-serif" }}>
                    {t.confirm}
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        <FooterLinks t={t}/>

        {phase === "error" && <ErrorModal t={t} onClose={resetToIdle}/>}
      </div>
    </>
  );
}
